import { useRouter } from 'next/router';
export const useQueryParam = (paramName) => {
    const router = useRouter();
    const { query } = router;
    const paramValue = query[paramName];
    return typeof paramValue === 'string' ? paramValue : null;
};
